import Dexie, { type EntityTable, type Table } from 'dexie';
import type { OutboxEntry, SettingRecord, SnapshotRecord, StoredAttachment, StudyRecord } from './types';

export const DEFAULT_DATABASE_NAME = 'nse-study-center-2026';

export class StudyDatabase extends Dexie {
  records!: EntityTable<StudyRecord, 'key'>;
  attachments!: EntityTable<StoredAttachment, 'id'>;
  settings!: EntityTable<SettingRecord, 'key'>;
  outbox!: EntityTable<OutboxEntry, 'id'>;
  snapshots!: EntityTable<SnapshotRecord, 'id'>;

  constructor(name = DEFAULT_DATABASE_NAME) {
    super(name);

    this.version(1).stores({
      records: '&key, type, id, studyDate, updatedAt, deletedAt',
      attachments: '&id, ownerKey, sha256, updatedAt, deletedAt',
      settings: '&key, updatedAt',
      outbox: '&id, entityKey, operation, createdAt',
      snapshots: '&id, createdAt, reason',
    });

    this.version(2).stores({
      records: '&key, type, id, studyDate, updatedAt, deletedAt, [type+studyDate]',
      attachments: '&id, ownerKey, sha256, updatedAt, deletedAt, [ownerType+ownerId]',
      settings: '&key, updatedAt',
      outbox: '&id, entityKey, operation, createdAt',
      snapshots: '&id, createdAt, reason',
    });
  }
}

let defaultDatabase: StudyDatabase | undefined;

export function getStudyDatabase(): StudyDatabase {
  defaultDatabase ??= new StudyDatabase();
  return defaultDatabase;
}

export type StudyTable = Table<StudyRecord, string>;

